import React from "react";

function LoadingIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={`${className}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M12 1V5"
          stroke="#DF1463"
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M19.4246 18.9246L16.5961 16.0962"
          stroke="#DF1463"
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M22.5 11.5L18.5 11.5"
          stroke="#DF1463"
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M12 18V22"
          stroke="#DF1463"
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M7.40381 6.90381L4.57538 4.07538"
          stroke="#DF1463"
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M5.5 11.5L1.5 11.5"
          stroke="#DF1463"
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M7.40381 16.0962L4.57538 18.9246"
          stroke="#DF1463"
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>{" "}
      </g>
    </svg>
  );
}

export default LoadingIcon;
